export const top10Gradients: [string, string][] = [
  ['purple-gradient-0', 'purple-gradient-1'],
  ['purple-gradient-0', 'purple-gradient-3'],
  ['purple-gradient-1', 'purple-gradient-4'],
];

export const worst10Gradients: [string, string][] = [
  ['purple-gradient-4', 'purple-gradient-5'],
  ['purple-gradient-3', 'purple-gradient-5'],
  ['purple-gradient-2', 'purple-gradient-5'],
];

export const ROW_LIST = [
  'My portfolio',
  'S&P 500',
  'Dow Jones',
  'NASDAQ',
  'Eurostoxx50',
  'Hang Seng',
];
